import { Injectable } from '@angular/core';

@Injectable()
export class PromiseQueue {
  private _runningPromise = Promise.resolve();
  constructor() {}

  queuePromise(fn: Function) {
    const newPromise = this._runningPromise.then(() => fn());
    this._runningPromise = newPromise;
    return this._runningPromise;
  }
}
